import { useMemo, useState } from 'react';
import CourseRow from '../components/CourseRow';
import ValidationAlert from '../components/ValidationAlert';
import FormulaModal from '../components/FormulaModal';
import ShareButton from '../components/ShareButton';
import StickyResultBar from '../components/StickyResultBar';
// import AdSlotPlaceholder from '../components/AdSlotPlaceholder';
import SEO from '../components/SEO';
import { calculateGpa } from '../utils/gpa';
import { ROUTE_META } from '../data/routeMeta';

function createCourse() {
  return { name: '', grade: 'S', credits: '3' };
}

export default function GpaCalculatorPage() {
  const [courses, setCourses] = useState([createCourse(), createCourse()]);
  const meta = ROUTE_META['/gpa-calculator'];

  const computed = useMemo(() => {
    if (courses.length === 0) {
      return { error: 'Add at least one course to calculate GPA.' };
    }
    return calculateGpa(courses);
  }, [courses]);

  const error = computed.error || '';
  const result = computed.error ? null : computed;

  function updateCourse(index, field, value) {
    setCourses((prev) => prev.map((course, i) => (i === index ? { ...course, [field]: value } : course)));
  }

  return (
    <>
      <SEO title={meta.title} description={meta.description} keywords={meta.keywords} canonicalPath="/gpa-calculator" />
      <section className="space-y-4 pb-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">VIT GPA Calculator</h1>
          <FormulaModal
            title="GPA Formula"
            formula="GPA = Sum(Grade Point x Credits) / Sum(Credits)"
            note="VIT mapping: S=10, A=9, B=8, C=7, D=6, E=5, F=0."
          />
        </div>

        <div className="grid grid-cols-12 gap-2 border-b border-brand-border pb-2 text-center text-xs font-semibold uppercase tracking-wide text-brand-muted">
          <p className="col-span-4">Course</p>
          <p className="col-span-3">Grade</p>
          <p className="col-span-4">Credits</p>
          <p className="col-span-1 text-right"> </p>
        </div>

        <div className="space-y-0">
          {courses.map((course, index) => (
            <CourseRow
              key={index}
              course={course}
              index={index}
              onChange={updateCourse}
              onRemove={(idx) => setCourses((prev) => prev.filter((_, i) => i !== idx))}
              disableRemove={courses.length <= 1}
            />
          ))}
        </div>

        <button
          type="button"
          onClick={() => setCourses((prev) => [...prev, createCourse()])}
          className="w-full rounded-xl border border-dashed border-brand-border py-2 text-sm font-medium text-brand-muted hover:border-brand-accent hover:text-brand-accent"
        >
          + Add another course
        </button>

        {/* <AdSlotPlaceholder label="Advertisement" className="xl:hidden rounded-2xl" /> */}
        <ValidationAlert message={error} />
      </section>

      <StickyResultBar
        label="Semester GPA"
        value={result ? result.value.toFixed(2) : ''}
        helper={result ? `${result.totalCredits.toFixed(1)} total credits` : ''}
        action={result ? <ShareButton textToCopy={`GradeVIT GPA Result: GPA ${result.value.toFixed(2)} with ${result.totalCredits.toFixed(1)} credits.`} /> : null}
      />
    </>
  );
}
